import {Component, OnInit} from '@angular/core';
import {HttpService} from '../service/http.service';
import {ActivatedRoute, Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  kazNews: any = [];
  worldNews: any = [];
  currentLang: any = sessionStorage.getItem('lang');

  constructor(private http: HttpService,
              private router: Router,
              private activatedRoute: ActivatedRoute,
              public translate: TranslateService) {
  }

  ngOnInit(): void {
    this.translate.onLangChange.subscribe((res) => {
      if (this.currentLang !== res.lang) {
        this.currentLang = res.lang;
        this.getNews();
      }
    });
    this.getNews();
  }

  redirectNewsPage(newId: any) {
    this.router.navigate(['/news/city', newId]);
  }

  getNews() {
    this.http.getKazNewsWithoutContent(this.currentLang).subscribe((res) => {
      this.kazNews = res;
    });
    this.http.getWorldNewsWithoutContent(this.currentLang).subscribe((res) => {
      this.worldNews = res;
    });
  }

}
